import styled from "styled-components";

import { pageRoot } from "../../../styles/pageRoot";
import { AddButton as SharedAddButton } from "../../../styles/adminPage";
import {
  md3CardRadius,
  md3FieldRadius,
} from "../../../shared/styles/md3Components";
import {
  actionListSubtitle,
  fontSizes,
  lineHeights,
  md3LabelLarge,
  sectionTitle,
} from "../../../shared/styles/typography";

export const Container = styled.div`
  ${pageRoot}
  background: ${({ theme }) => theme.colors.layoutBg};
`;

export const FilterBar = styled.div`
  width: 90%;
  max-width: 1100px;
  margin: -24px auto 0;
  background: ${({ theme }) => theme.colors.card};
  border-radius: ${({ theme }) => md3CardRadius(theme)}px;
  box-shadow: ${({ theme }) => theme.shadows.md3Level2};
  border: 1px solid ${({ theme }) => theme.colors.border};
  padding: 1.6rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  flex-wrap: wrap;
  position: relative;
  z-index: 10;
`;

export const FilterGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex: 1;
  flex-wrap: wrap;
  align-items: center;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: ${({ theme }) => theme.colors.surfaceSecondary};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => md3FieldRadius(theme)}px;
  padding: 0.8rem 1.2rem;
  flex: 1;
  min-width: 200px;
  transition: border-color 0.2s, background 0.2s;
  color: ${({ theme }) => theme.colors.textSecondary};

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.surface};
  }
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  font-size: ${fontSizes.base}px;
  color: ${({ theme }) => theme.colors.text};
  width: 100%;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textTertiary};
  }
`;

export const SelectFilter = styled.select`
  background: ${({ theme }) => theme.colors.surfaceSecondary};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => md3FieldRadius(theme)}px;
  padding: 0.8rem 1.2rem;
  font-size: ${fontSizes.base}px;
  color: ${({ theme }) => theme.colors.text};
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s;
  min-width: 160px;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const AddButton = SharedAddButton;

export const Main = styled.main`
  flex: 1;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 3.2rem 1.2rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  @media (min-width: 900px) {
    padding: 4rem 0 5rem;
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.6rem;

    @media (min-width: 640px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 960px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

export const TotalBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  ${md3LabelLarge}
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: 1.6rem;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6rem 2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.textTertiary};

  h2 {
    ${sectionTitle}
    margin: 1.6rem 0 0.6rem;
  }

  p {
    ${actionListSubtitle}
    margin-bottom: 2.4rem;
  }

  button {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    min-height: 48px;
    padding: 0 2.4rem;
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.titleOnPrimary};
    font-size: ${fontSizes.base}px;
    line-height: ${lineHeights.base}px;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    border: none;
    border-radius: ${({ theme }) => theme.layout.radiusMd};
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }
`;
